module.exports = __webpack_public_path__ + "img/banner3.53a80061.jpg";